import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faQrcode, faList, faListUl, faChartLine, faBarChart, faRectangleList, faBox, faSpider, faWaveSquare, faWaterLadder, faChartPie, faImages } from '@fortawesome/free-solid-svg-icons';
import './BigData.css';
// import bigdataimage from '../../assets/pageimages/BigData.webp';

function BigDataHome() {

  return (
    <div className="min-h-screen bg-black py-4">
      
      <div className="min-h-[80vh] lg:min-h-[92vh] px-2 mx-auto">
        <div className="flex justify-start mb-2 border-b border-blue-400">
            <h2 className="text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-4 px-4">🗄️📊 Big Data</h2>
        </div>
        <div className="min-h-[100vh] px-4">
          {/* <div className="flex justify-center mb-6">
            <img 
              id="bigdata-id" 
              src={bigdataimage} 
              alt="BigData visual representation" 
              className="rounded-lg shadow-lg w-full max-w-md"
            />
          </div> */}
           <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-250">
            {/* <Link to="/bigdata-book-readlog-timeline" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faChartLine} className="text-3xl mb-2" />
              <span>Book Read Timeline Graph</span>
            </Link>

            <Link to="/bigdata-book-readlog-pageread" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faBarChart} className="text-3xl mb-2" />
              <span>Book Read Page Count Graph</span>
            </Link>

            <Link to="/bigdata-violin-chart" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faWaveSquare} className="text-3xl mb-2" />
              <span>Violin</span>
            </Link>

            <Link to="/bigdata-box-and-whisker-chart" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faBox} className="text-3xl mb-2" />
              <span>Box-and-Whisker</span>
            </Link>

            <Link to="/bigdata-candle-stick-chart" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faRectangleList} className="text-3xl mb-2" />
              <span>Candle Stick</span>
            </Link>

            <Link to="/bigdata-spider-chart" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faSpider} className="text-3xl mb-2" />
              <span>Spider</span>
            </Link>

            <Link to="/bigdata-water-wheel-chart" className="flex flex-col items-center justify-center text-center text-white hover:text-blue-400 transition">
              <FontAwesomeIcon icon={faWaterLadder} className="text-3xl mb-2" />
              <span>Waterwheel</span>
            </Link> */}

            <CardLink to="/bigdata-book-readlog-timeline" icon={faChartLine} text="Book Read Timeline Graph" />
            <CardLink to="/bigdata-book-readlog-pageread" icon={faBarChart} text="Book Read Page Count Graph" />
            <CardLink to="/bigdata-violin-chart" icon={faWaveSquare} text="Violin" />
            <CardLink to="/bigdata-box-and-whisker-chart" icon={faBox} text="Box-and-Whisker" />
            <CardLink to="/bigdata-candle-stick-chart" icon={faRectangleList} text="Candle Stick" />
            <CardLink to="/bigdata-spider-chart" icon={faSpider} text="Spider" />
            <CardLink to="/bigdata-water-wheel-chart" icon={faWaterLadder} text="Waterwheel" />

            {/* <div className="flex flex-col items-center justify-center text-center text-gray-200 opacity-50 pointer-events-none">
              <FontAwesomeIcon icon={faList} className="text-3xl mb-2" />
              <span>Data Checklists</span>
            </div>

            <div className="flex flex-col items-center justify-center text-center text-gray-200 opacity-50 pointer-events-none">
              <FontAwesomeIcon icon={faQrcode} className="text-3xl mb-2" />
              <span>Statistics & Insights</span>
            </div>

            <div className="flex flex-col items-center justify-center text-center text-gray-200 opacity-50 pointer-events-none">
              <FontAwesomeIcon icon={faListUl} className="text-3xl mb-2" />
              <span>Data Visualisation</span>
            </div>

            <div className="flex flex-col items-center justify-center text-center text-gray-200 opacity-50 pointer-events-none">
              <FontAwesomeIcon icon={faQrcode} className="text-3xl mb-2" />
              <span>Infographics Reports</span>
            </div> */}

            <CardNoLink to="" icon={faList} text="Data Checklists" />
            <CardNoLink to="" icon={faChartLine} text="Statistics & Insights" />
            <CardNoLink to="" icon={faChartPie} text="Data Visualisation" />
            <CardNoLink to="" icon={faImages} text="Infographics Reports" />

          </div>
        </div>

      </div>
    <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default BigDataHome;
